export default __webpack_public_path__ + "static/media/linkedin_icon.2943a06e.svg";